import { useQuery } from '@tanstack/react-query';
import { cdfService } from 'v2/services/cdfService';

export const useLoadFiles = (id: number) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['cdf', 'loadFiles', id],
    queryFn: () => cdfService.getDetailsFiles(id),
    enabled: !!id
  });

  return {
    files: data?.data ?? [],
    isLoading,
    error,
    refetch
  };
};
